import { EuroValue, ICostForCareLevels } from '@dokucoach/common-types';
import { array, date, number, object } from 'yup';
import { ICostForCareLevelsCreate, ICostForCareLevelsCreateSchema } from './ICostForCareLevels';
import { ITrainingLevy, ITrainingLevyCreate, ITrainingLevyCreateSchema } from './ITrainingLevy';

export type INursingHomeInvoicingCostRatesConfig = {
  id: string;
  nursingHomeId: string;
  validFrom: Date;
  consistentPrivateContribution: number;
  careCosts: ICostForCareLevels;
  insuranceCareCostCoverage: ICostForCareLevels;
  accommodationCostsPerDay: number;
  lodgingCostsPerDay: number;
  investmentCostsPerDay: number;
  surcharge43bCostsPerDay: number;
  surcharge84p9CostsPerDay: number;
  percentageDiscountAbsenceCareCosts: number;
  percentageDiscountAbsenceAccommodationCosts: number;
  percentageDiscountAbsenceLodgingCosts: number;
  percentageDiscountAbsenceTrainingLevyCosts: number;
  discountTubeFeedingPerDay: number;
  shortTermCareYearlyBenefitAmount: number;
  substituteCareYearlyBenefitAmount: number;
  trainingLevies?: ITrainingLevy[];
  createdAt: Date;
};

export type INursingHomeInvoicingCostRatesConfigCreate = {
  validFrom: Date;
  consistentPrivateContribution: number;
  careCosts: ICostForCareLevelsCreate;
  insuranceCareCostCoverage: ICostForCareLevelsCreate;
  accommodationCostsPerDay: number;
  lodgingCostsPerDay: number;
  investmentCostsPerDay: number;
  surcharge43bCostsPerDay: number;
  surcharge84p9CostsPerDay: number;
  percentageDiscountAbsenceCareCosts: number;
  percentageDiscountAbsenceAccommodationCosts: number;
  percentageDiscountAbsenceLodgingCosts: number;
  percentageDiscountAbsenceTrainingLevyCosts: number;
  discountTubeFeedingPerDay: number;
  shortTermCareYearlyBenefitAmount: number;
  substituteCareYearlyBenefitAmount: number;
  trainingLevies: ITrainingLevyCreate[];
};

export const INursingHomeInvoicingCostRatesConfigCreateSchema = object({
  validFrom: date().required(),
  consistentPrivateContribution: EuroValue.required(),
  careCosts: ICostForCareLevelsCreateSchema.required().default(undefined),
  insuranceCareCostCoverage: ICostForCareLevelsCreateSchema.required().default(undefined),
  accommodationCostsPerDay: EuroValue.required(),
  lodgingCostsPerDay: EuroValue.required(),
  investmentCostsPerDay: EuroValue.required(),
  surcharge43bCostsPerDay: EuroValue.required(),
  surcharge84p9CostsPerDay: EuroValue.required(),
  percentageDiscountAbsenceCareCosts: number().min(0).max(100).required(),
  percentageDiscountAbsenceAccommodationCosts: number().min(0).max(100).required(),
  percentageDiscountAbsenceLodgingCosts: number().min(0).max(100).required(),
  percentageDiscountAbsenceTrainingLevyCosts: number().min(0).max(100).required(),
  discountTubeFeedingPerDay: EuroValue.required(),
  shortTermCareYearlyBenefitAmount: EuroValue.required(),
  substituteCareYearlyBenefitAmount: EuroValue.required(),
  trainingLevies: array().ensure().compact().of(ITrainingLevyCreateSchema),
});
